import {Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[appNumbersOnly]',
})
export class NumbersOnlyDirective {

  @Input()
  withPeriod = false;

  private readonly COMMA = ',';
  private readonly PERIOD = '.';

  constructor(private el: ElementRef) {
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {

    if (!this.withPeriod && (event.key === this.PERIOD || event.key === this.COMMA)) {
      event.preventDefault()
    }

  }
}
